module.exports = __webpack_public_path__ + "img/contact_us_banner.f0468fe0.jpg";